<template>
  <div class="statistics">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label name></el-tab-pane>
      <el-tab-pane
        v-if="hasPerm('statistics:data:dept')"
        label="部门统计"
        name="area"
        class="table"
      >
        <el-main class="statisticsBox">
          <el-row class="selectBox">
            <el-input
              class="selectInput"
              v-model="udeptName"
              @click.native="clickInput"
              placeholder="请选择部门"
              readonly
            ></el-input>
            <el-row class="deptTree" :class="{ active: show == true }">
              <el-row class="custom-tree-container">
                <el-row class="block">
                  <el-tree
                    :data="udeptTreeData"
                    node-key="id"
                    @node-click="deptChange"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                  >
                    <span
                      class="custom-tree-node is-show"
                      slot-scope="{ node }"
                    >
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                </el-row>
              </el-row>
            </el-row>
          </el-row>
          <el-row class="reloadTime">
            <span>数据刷新时间：</span>
            <span>{{ deptPower.flushTime }}</span>
            <span class="reload" @click="reloadData()"
              >刷新 <img src="../../../assets/images/statistic/reload.png"
            /></span>
          </el-row>
          <el-row class="numBoxs">
            <el-col :span="7" class="numBox">
              <el-row class="titleBox">
                <el-col :span="4" class="statisticsTitle">车辆总数</el-col>
                <el-col :span="15" class="statisticsNum">{{
                  deptPower.vehicleCount
                }}</el-col>
                <el-col :span="2" class="statisticsImg">
                  <img src="../../../assets/images/statistic/car.png" />
                </el-col>
              </el-row>
              <el-row class="itemBox">
                <el-col :span="7">
                  <span class="itemTitle">在线</span>
                  <span class="itemNum">{{ deptPower.vehicleOnline }}</span>
                </el-col>
                <el-col :span="7" style="margin:0px 25px;">
                  <span class="itemTitle">待命</span>
                  <span class="itemNum offline">{{
                    deptPower.vehicleOffline
                  }}</span>
                </el-col>
                <el-col :span="7">
                  <span class="itemTitle">发电中</span>
                  <span class="itemNum powering">{{
                    deptPower.vehiclePowerCount
                  }}</span>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :span="7"
              class="numBox"
              style="margin-left:90px;margin-right:90px"
            >
              <el-row class="titleBox">
                <el-col :span="4" class="statisticsTitle">车主总数</el-col>
                <el-col :span="15" class="statisticsNum">{{
                  deptPower.personnelCount
                }}</el-col>
                <el-col :span="2" class="statisticsImg">
                  <img src="../../../assets/images/statistic/carPerson.png" />
                </el-col>
              </el-row>
              <el-row class="itemBox">
                <el-col :span="7">
                  <span class="itemTitle">在线</span>
                  <span class="itemNum">{{ deptPower.personnelOnline }}</span>
                </el-col>
                <el-col :span="7" style="margin:0px 25px;">
                  <span class="itemTitle">待命</span>
                  <span class="itemNum offline">{{
                    deptPower.personnelOffline
                  }}</span>
                </el-col>
                <el-col :span="7">
                  <span class="itemTitle">今日登录</span>
                  <span class="itemNum loginItem">{{
                    deptPower.personnelLogin
                  }}</span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7" class="numBox">
              <el-row class="titleBox">
                <el-col :span="4" class="statisticsTitle">本月派单</el-col>
                <el-col :span="15" class="statisticsNum">{{
                  deptPower.orderMonthCount
                }}</el-col>
                <el-col :span="2" class="statisticsImg">
                  <img src="../../../assets/images/statistic/order.png" />
                </el-col>
              </el-row>
              <el-row class="itemBox">
                <el-col :span="7">
                  <span class="itemTitle">待接单</span>
                  <span class="itemNum">{{ deptPower.orderWaitCount }}</span>
                </el-col>
                <el-col :span="7" style="margin:0px 25px;">
                  <span class="itemTitle">待回单</span>
                  <span class="itemNum offline">{{
                    deptPower.orderAlreadyCount
                  }}</span>
                </el-col>
                <el-col :span="7">
                  <span class="itemTitle">待审核</span>
                  <span class="itemNum loginItem">{{
                    deptPower.orderReviewCount
                  }}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="chartBoxs">
            <el-row class="chartBox">
              <el-row class="chartTitle"
                >当前工单超时分布（接单超过2小时）</el-row
              >
              <el-row id="outTimeChart" class="charts"></el-row>
            </el-row>
            <el-row class="chartBox">
              <el-row class="chartTitle">当前发电工单分布</el-row>
              <el-row id="currentOrderChart" class="charts"></el-row>
            </el-row>
            <el-radio-group
              class="selectTime"
              v-model="timeType"
              @change="timeChange()"
            >
              <el-radio label="1" border>近7天</el-radio>
              <el-radio label="2" border>近30天</el-radio>
            </el-radio-group>
            <el-row class="chartBox">
              <el-row class="chartTitle">区域发电量统计（KW·H）</el-row>
              <el-row id="powerNumChart" class="charts"></el-row>
            </el-row>
            <el-row class="chartBox">
              <el-row class="chartTitle">区域发电时长统计（分钟）</el-row>
              <el-row id="powerTimeChart" class="charts"></el-row>
            </el-row>
            <el-row class="chartBox">
              <el-row class="chartTitle">区域发电油耗统计（升）</el-row>
              <el-row id="powerOilChart" class="charts"></el-row>
            </el-row>
          </el-row>
        </el-main>
      </el-tab-pane>
      <el-tab-pane
        v-if="hasPerm('statistics:data:personnel')"
        label="个人统计"
        name="personal"
        class="table"
      >
        <el-row class="statisticsPerson">
          <el-col class="personLeft">
            <el-row class="leftHeader">
              <span>个人总发电量排行</span>
              <span class="time">截止时间：{{ rankingData.deadlineTime }}</span>
            </el-row>
            <el-row class="topThree">
              <el-col class="No noTwo" v-if="topTwo">
                <el-row class="name">{{ topTwo.personnelName }}</el-row>
                <el-row class="power">{{ topTwo.capacity }}</el-row>
                <el-row class="unit">kW·h</el-row>
                <el-row class="carNumber" :title="topTwo.plateNum">{{
                  topTwo.plateNum
                }}</el-row>
                <el-row class="account">{{ topTwo.account }}</el-row>
              </el-col>
              <el-col class="No noOne" v-if="topOne">
                <el-row class="name">{{ topOne.personnelName }}</el-row>
                <el-row class="power">{{ topOne.capacity }}</el-row>
                <el-row class="unit">kW·h</el-row>
                <el-row class="carNumber" :title="topOne.plateNum">{{
                  topOne.plateNum
                }}</el-row>
                <el-row class="account">{{ topOne.account }}</el-row>
              </el-col>
              <el-col class="No noThree" v-if="topThree">
                <el-row class="name">{{ topThree.personnelName }}</el-row>
                <el-row class="power">{{ topThree.capacity }}</el-row>
                <el-row class="unit">kW·h</el-row>
                <el-row class="carNumber" :title="topThree.plateNum">{{
                  topThree.plateNum
                }}</el-row>
                <el-row class="account">{{ topThree.account }}</el-row>
              </el-col>
            </el-row>
            <template>
              <el-table
                :show-header="false"
                :data="rankingTable"
                stripe
                style="width: 100%"
              >
                <el-table-column type="index" :index="indexMethod" width="50">
                </el-table-column>
                <el-table-column
                  prop="personnelName"
                  label="车辆绑定人"
                  width="80"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="account"
                  label="账号"
                  width="120"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="plateNum"
                  label="车牌号"
                  width="120"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="capacity"
                  label="发电量"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.capacity }}KW·H</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-col>
          <el-col class="personRight" :lg="10" :xl="15">
            <el-row class="query">
              <el-col :span="5">
                <el-input
                  size="small"
                  placeholder="请输入运维人员账号"
                  v-model="acount"
                  clearable
                >
                </el-input>
              </el-col>
              <el-button type="primary" class="queryBtn" @click="query()"
                >查询</el-button
              >
            </el-row>
            <el-row class="queryContent" v-if="personData.personnelName">
              <el-row class="userDetail">
                <el-col :span="4">
                  <img src="../../../assets/images/statistic/user.png" />
                </el-col>
                <el-col :span="12">
                  <el-row class="userName">
                    <div>{{ personData.personnelName }}</div>
                    （
                    <div class="userName-plateNum" :title="personData.plateNum">
                      {{ personData.plateNum }}
                    </div>
                    ）
                  </el-row>
                  <el-row class="userPhone">{{
                    personData.personnelPhone
                  }}</el-row>
                  <el-row class="userCompany">{{
                    personData.companyName
                  }}</el-row>
                  <el-row class="userDept">{{ personData.groupName }}</el-row>
                </el-col>
              </el-row>
              <el-row class="userData">
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">发电量</el-row>
                  <el-row class="itemData">{{ personData.capacity }}</el-row>
                  <el-row class="itemUnit">kW·h</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">发电时长</el-row>
                  <el-row class="itemData">{{ personData.duration }}</el-row>
                  <el-row class="itemUnit">分钟</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">发电油耗</el-row>
                  <el-row class="itemData">{{ personData.oil }}</el-row>
                  <el-row class="itemUnit">升</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">完成工单</el-row>
                  <el-row class="itemData">{{ personData.orderNum }}</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">平均接单时间</el-row>
                  <el-row class="itemData">{{
                    personData.orderAverageTime
                  }}</el-row>
                  <el-row class="itemUnit">分钟</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">工单完成率</el-row>
                  <el-row class="itemData"
                    >{{ personData.orderCompleteRate }}%</el-row
                  >
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">审核通过率</el-row>
                  <el-row class="itemData"
                    >{{ personData.orderReviewRate }}%</el-row
                  >
                </el-col>
              </el-row>
            </el-row>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane
        v-if="hasPerm('statistics:data:station')"
        label="基站统计"
        name="baseStation"
        class="table"
      >
        <el-row class="statisticsPerson">
          <el-col class="personLeft">
            <el-row
              class="leftHeader"
              style="border-left: 3px solid #0093ff;text-align:left;padding-left:15px;padding-bottom:0px"
            >
              <span>近30天发电量排行</span>
              <span class="time">注：未发过电的基站不在排行内</span>
            </el-row>
            <template>
              <el-table
                :show-header="false"
                :data="stationData"
                stripe
                style="width: 100%"
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                  prop="name"
                  label="基站名称"
                  width="350"
                ></el-table-column>
                <el-table-column prop="power" label="发电量" width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.power }}KW·H</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-col>
          <el-col class="personRight" :lg="10" :xl="15">
            <el-form
              size="medium"
              :inline="true"
              :model="queryForm"
              ref="queryForm"
              @submit.native.prevent
            >
              <el-form-item class="r-10" prop="stationId">
                <el-select
                  v-model="queryForm.stationId"
                  clearable
                  filterable
                  remote
                  reserve-keyword
                  placeholder="站址名称"
                  :remote-method="remoteMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.stationId"
                    :label="item.name"
                    :value="item.stationId"
                  >
                  </el-option>
                </el-select>

                <!-- <el-input
                    v-model="queryForm.stationId"
                    @keyup.enter.native="queryStation"
                    placeholder="站址名称"
                  >
                  </el-input> -->
              </el-form-item>
              <el-form-item>
                <date-picker
                  :startTime="queryForm.startTime"
                  :endTime="queryForm.endTime"
                  @changeStart="changeStart"
                  @changeEnd="changeEnd"
                >
                </date-picker>
              </el-form-item>
              <el-button
                v-if="hasPerm('statistics:data:station')"
                type="primary"
                @click="queryStation"
                >查询</el-button
              >
            </el-form>
            <el-row class="queryContent" v-if="stationItemData.code">
              <el-row class="userDetail">
                <el-col :span="4">
                  <img src="../../../assets/images/statistic/baseStation.png" />
                </el-col>
                <el-col :span="12">
                  <el-row class="userName"> {{ stationItemData.name }} </el-row>
                  <el-row class="userPhone">
                    {{ stationItemData.code }}
                  </el-row>
                  <el-row class="userCompany">
                    {{ stationItemData.areaName }}
                  </el-row>
                  <el-row class="userDept">
                    {{ stationItemData.dcLoadCurrent }}A
                  </el-row>
                </el-col>
              </el-row>
              <el-row class="userData">
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">发电量</el-row>
                  <el-row class="itemData">{{
                    stationItemData.capacity
                  }}</el-row>
                  <el-row class="itemUnit">kW·h</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">发电时长</el-row>
                  <el-row class="itemData">{{
                    stationItemData.duration
                  }}</el-row>
                  <el-row class="itemUnit">分钟</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">发电油耗</el-row>
                  <el-row class="itemData">{{
                    stationItemData.oilConsume
                  }}</el-row>
                  <el-row class="itemUnit">升</el-row>
                </el-col>
                <el-col :span="5" class="userDataItem">
                  <el-row class="itemTitle">派单量</el-row>
                  <el-row class="itemData">{{
                    stationItemData.orderTotal
                  }}</el-row>
                </el-col>
              </el-row>
            </el-row>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DatePicker from "@/components/DatePicker.vue";
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      loading: false,
      queryForm: {},
      stationData: {},
      stationItemData: {},
      options: [],
      deptProps: {
        children: "children",
        value: "id",
        label: "label",
        checkStrictly: true,
        emitPath: false,
      },
      deptId: "",
      udeptName: "",
      udeptTreeData: [],
      acount: "",
      rankingTable: [],
      activeName: "area",
      deptPower: {},
      orderx: [],
      ordery: [],
      orderTimeOutx: [],
      orderTimeOuty: [],
      areax: [],
      areaOil: [],
      areaPower: [],
      areaDuration: [],
      timeType: "1",
      rankingData: {},
      topOne: {},
      topTwo: {},
      topThree: {},
      personData: {},
      powerOilChart: "",
      powerTimeChart: "",
      powerNumChart: "",
      outTimeChart: "",
      currentOrderChart: "",
      show: false,
    };
  },
  mounted() {
    this.currentOrderChart = this.$echarts.init(
      document.getElementById("currentOrderChart")
    );
    this.outTimeChart = this.$echarts.init(
      document.getElementById("outTimeChart")
    );
    this.powerNumChart = this.$echarts.init(
      document.getElementById("powerNumChart")
    );
    this.powerTimeChart = this.$echarts.init(
      document.getElementById("powerTimeChart")
    );
    this.powerOilChart = this.$echarts.init(
      document.getElementById("powerOilChart")
    );
    //加loading效果
    this.getDeptTree();
    this.deptPowerData();
    this.orderData();
    this.orderTimeOutData();
    this.areaData();
  },
  methods: {
    async remoteMethod(query) {
      let _this = this;
      console.log(query);
      if (query !== "") {
        _this.loading = true;
        let { data: res } = await _this.$axios.get(
          `/api/base/station/options/${query}`
        );
        if (res.code == 1) {
          _this.loading = false;
          _this.options = res.data;
        } else {
          _this.$message.warning(res.msg);
        }
      } else {
        _this.options = [];
      }
    },
    changeStart(val) {
      this.queryForm.startTime = val;
    },
    changeEnd(val) {
      this.queryForm.endTime = val;
    },
    clickInput() {
      this.show = !this.show;
    },
    async getDeptTree() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        _this.udeptTreeData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    indexMethod(index) {
      return index + 4;
    },
    reloadData() {
      this.deptPowerData();
      this.orderData();
      this.orderTimeOutData();
      this.areaData();
    },
    timeChange() {
      this.areaData();
    },
    // 获取部门发电统计
    async deptPowerData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/dept?deptId=" + _this.deptId
      );
      if (res.code == 1) {
        _this.deptPower = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取当前工单统计
    async orderData() {
      let _this = this;
      _this.orderx = [];
      _this.ordery = [];
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/dept/order?deptId=" + _this.deptId
      );
      if (res.code == 1) {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            _this.orderx.push(res.data[i].name);
            _this.ordery.push(res.data[i].orderCount);
          }
        }
        _this.initCharts(_this.currentOrderChart, _this.orderx, _this.ordery);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取当前超时工单统计
    async orderTimeOutData() {
      let _this = this;
      _this.orderTimeOutx = [];
      _this.orderTimeOuty = [];
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/dept/order/timeout?deptId=" + _this.deptId
      );
      if (res.code == 1) {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            _this.orderTimeOutx.push(res.data[i].name);
            _this.orderTimeOuty.push(res.data[i].orderCount);
          }
        }
        _this.initCharts(
          _this.outTimeChart,
          _this.orderTimeOutx,
          _this.orderTimeOuty
        );
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取当前区域发电统计
    async areaData() {
      let _this = this;
      _this.areax = [];
      _this.areaOil = [];
      _this.areaPower = [];
      _this.areaDuration = [];
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/dept/area?deptId=" +
          _this.deptId +
          "&timeType=" +
          _this.timeType
      );
      if (res.code == 1) {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            _this.areax.push(res.data[i].name);
            _this.areaOil.push(res.data[i].oil);
            _this.areaPower.push(res.data[i].capacity);
            _this.areaDuration.push(res.data[i].duration);
          }
        }
        _this.initCharts(_this.powerNumChart, _this.areax, _this.areaPower);
        _this.initCharts(_this.powerTimeChart, _this.areax, _this.areaDuration);
        _this.initCharts(_this.powerOilChart, _this.areax, _this.areaOil);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    deptChange(value) {
      this.udeptName = value.label;
      this.deptId = value.id;
      this.reloadData();
      this.show = !this.show;
    },
    // 获取个人发电排行统计
    async getRankingData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/personnel/ranking"
      );
      if (res.code == 1) {
        _this.rankingData = res.data;
        // _this.rankingTable = _this.rankingData.rankling;
        if (_this.rankingData.rankling.length > 0) {
          //测试数据少，后期删掉
          _this.topOne = _this.rankingData.rankling[0];
        }
        if (_this.rankingData.rankling.length > 1) {
          //测试数据少，后期删掉
          _this.topTwo = _this.rankingData.rankling[1];
        }
        if (_this.rankingData.rankling.length > 2) {
          //测试数据少，后期删掉
          _this.topThree = _this.rankingData.rankling[2];
        }
        if (_this.rankingData.rankling.length > 3) {
          //测试数据少，后期删掉
          _this.rankingTable = _this.rankingData.rankling.slice(3);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //  查询个人发电统计
    async getPersonData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/personnel/" + _this.acount
      );
      if (res.code == 1) {
        _this.personData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取基站发电量排行
    async getStationData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/station/ranking"
      );
      if (res.code == 1) {
        _this.stationData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //  查询基站发电统计
    async getStationItemData() {
      let _this = this;
      if (!_this.queryForm.stationId) {
        _this.$message.warning("请输入基站名称");
        return;
      }
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/station",
        {
          params: _this.queryForm,
        }
      );
      if (res.code == 1) {
        _this.stationItemData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    query() {
      this.getPersonData();
    },
    queryStation() {
      this.getStationItemData();
    },
    handleClick(tab) {
      if (tab.name == "area") {
        this.deptPowerData();
        this.orderData();
        this.orderTimeOutData();
        this.areaData();
      } else if (tab.name == "personal") {
        this.getRankingData();
      } else {
        this.getStationData();
      }
    },
    initCharts(myChart, datax, datay) {
      let showed = datay.length ? false : true;
      myChart.setOption({
        title: {
          show: showed,
          text: "暂无数据...",
          left: "center",
          top: "center",
          textStyle: {
            fontWeight: "normal",
            color: "#999999",
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "10%",
          bottom: "12%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          data: datax,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            data: datay,
            type: "bar",
            itemStyle: {
              normal: {
                color: "#5A78D4",
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 16,
                  },
                },
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: 0,
            filterMode: "none",
          },
          {
            type: "inside",
            xAxisIndex: 0,
            filterMode: "none",
          },
        ],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tabs {
  height: calc(100% - 10px);
  /deep/ .el-tabs__content {
    height: calc(100% - 40px);
    overflow: auto;
    .el-tab-pane {
      height: 100%;
    }
  }
}
.el-tabs /deep/ .el-tabs__header {
  background: #fff;
  margin-bottom: 20px;
}
.el-tabs /deep/ #tab-0 {
  padding: 0;
  height: 0;
}
/deep/ .el-radio {
  padding: 0;
  width: 80px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  border-radius: 16px;
  .el-radio__label {
    padding: 0;
    font-size: 14px;
  }
}
/deep/ .el-radio__inner {
  display: none;
}
.statistics {
  margin: 20px;
  height: calc(100% - 40px);
  background-color: #f8f8f8;
  .statisticsBox {
    width: 100%;
    height: calc(100% - 10px);
    background: #fff;
    // overflow-y: auto;
    .reloadTime {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      padding: 10px 0px;
      .reload {
        margin-left: 10px;
        cursor: pointer;
        position: relative;
        color: #0094ff;
        img {
          position: absolute;
          top: 0px;
        }
      }
    }
    .numBoxs {
      .numBox {
        width: 450px;
        height: 160px;
        background: #f4f4f4;
        border-radius: 6px;
        padding: 20px !important;
        margin-bottom: 10px;
        .titleBox {
          .statisticsTitle {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
            margin-top: 20px;
            margin-right: 10px;
          }
          .statisticsNum {
            margin-top: 5px;
            font-size: 32px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #0094ff;
          }
        }
        .itemBox {
          padding-top: 30px;
          .itemTitle {
            font-size: 14px;
            color: #333333;
            margin-right: 6px;
          }
          .itemNum {
            font-size: 24px;
            color: #02d34c;
          }
          .offline {
            color: #f6392a;
          }
          .powering {
            color: #09ebee;
          }
          .loginItem {
            color: #0094ff;
          }
        }
      }
    }
    .selectTime {
      margin: 10px 0px !important;
    }
    .chartBoxs {
      .chartBox {
        .chartTitle {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          margin: 10px 0px;
          padding-left: 10px;
          border-left: 3px solid #0093ff;
        }
        .charts {
          width: 100%;
          height: 300px;
        }
      }
    }
  }
  .statisticsPerson {
    width: 100%;
    height: calc(100% - 10px);
    display: flex;
    flex-flow: row;
    .personLeft {
      width: 550px;
      background: #fff;
      padding: 20px !important;
      height: 100%;
      .leftHeader {
        font-size: 18px;
        padding-bottom: 10px;
        font-weight: bold;
        color: #333333;
        text-align: center;
        position: relative;
        .time {
          position: absolute;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          top: 5px;
          right: 0px;
        }
      }
      .topThree {
        width: 508px;
        height: 260px;
        background: url("../../../assets/images/statistic/rankingList.png")
          no-repeat;
        background-size: 100% 100%;
        position: relative;
        .No {
          position: absolute;
          font-family: Source Han Sans CN;
          text-align: center;
          width: 150px;
          line-height: 30px;
          .name {
            font-size: 18px;
            font-weight: 500;
            color: #2c2c2c;
          }
          .power {
            font-size: 24px;
            font-weight: 500;
            color: #ff8400;
          }
          .unit {
            font-size: 14px;
            font-weight: 500;
            color: #999999;
          }
          .carNumber {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 18px;
            font-weight: 500;
            color: #2c2c2c;
            line-height: 17px;
          }
          .account {
            height: 40px;
            line-height: 40px;
          }
        }
        .noOne {
          top: 75px;
          left: 178px;
          .name {
            font-size: 20px;
          }
          .power {
            font-size: 32px;
            line-height: 40px;
          }
          .unit {
            font-size: 18px;
          }
          .carNumber {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 20px;
            line-height: 35px;
          }
          .account {
            height: 40px;
            line-height: 40px;
            font-size: 18px;
          }
        }
        .noTwo {
          top: 115px;
        }
        .noThree {
          top: 115px;
          right: 0;
        }
      }
    }
    .personRight {
      height: 100%;
      background: #fff;
      padding: 20px !important;
      margin-left: 15px;
      flex: 1;
      .query {
        .queryBtn {
          margin-left: 10px;
        }
      }
      .queryContent {
        padding-top: 20px;
        .userDetail {
          font-weight: bold;
          color: #333333;
          line-height: 25px;
          font-size: 14px;
          .userName {
            display: flex;
            white-space: nowrap;
            height: 50px;
            line-height: 50px;
            font-size: 24px;
            .userName-plateNum {
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
        .userData {
          padding-top: 10px;
          .userDataItem {
            height: 120px;
            background: #f4f4f4;
            border-radius: 6px;
            padding: 10px !important;
            margin-right: 20px;
            margin-bottom: 20px;
            .itemTitle {
              font-size: 16px;
              color: #333333;
            }
            .itemData {
              font-size: 28px;
              color: #0094ff;
              line-height: 55px;
            }
            .itemUnit {
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }
  }
}

.selectBox .selectInput /deep/ .el-input__inner {
  width: 250px;
  cursor: pointer !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.deptTree {
  width: 250px;
  max-height: 600px;
  overflow: auto;
  margin-left: 18px;
  position: absolute;
  top: 40px;
  font-size: 14px;
  display: none;
  z-index: 999;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(153, 153, 153, 0.3);
  background: #fff;
}
.deptTree.active {
  display: block;
}
</style>
